import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "finance-bar" }
const _hoisted_2 = { class: "action-btn-inner flex justify-center" }
const _hoisted_3 = { class: "catch-btn-wrap" }
const _hoisted_4 = { class: "ball-count-wrap flex justify-center" }
const _hoisted_5 = { class: "ball-count-text" }
const _hoisted_6 = { class: "action-btn-inner flex justify-center" }

import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useReddotStore } from '@/store';
import Reward from './Reward';
import { queryCatchDoll, catchDoll } from '@/api';


export default {
  __name: 'FinanceBar',
  setup(__props) {

const redDotStore = useReddotStore();
const { catchDollCount } = storeToRefs(redDotStore);

const rewards = ref([])
const showReward = ref(false)

// onMounted(() => {
//   fetchCatchDoll()
// })

// const fetchCatchDoll = () => {
//   queryCatchDoll().then(res => {
//     ballCount.value = res.data?.chance || 0
//   })
// }

const doCatchDoll = () => {
  catchDoll().then(res => {
    const { bonus, remark } = res.data || {};
    rewards.value = [{ type: "doll", amount: bonus, dollType: remark }];
    showReward.value = true
    redDotStore.dollCatch()
  })
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_button = _resolveComponent("van-button")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "action-btn",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push({ name: 'withdraw' })))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          class: "action-btn-icon",
          fit: "contain",
          src: require('@/assets/img/home/finance-bar/withdraw-icon.png')
        }, null, 8, ["src"]),
        _createVNode(_component_van_image, {
          class: "action-btn-text",
          fit: "contain",
          src: require('@/assets/img/home/finance-bar/withdraw-text.png')
        }, null, 8, ["src"])
      ])
    ])), [
      [_directive_audio]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_van_image, {
        class: _normalizeClass(["catch-btn-bg", { active: _unref(catchDollCount) > 0 }]),
        fit: "contain",
        src: require('@/assets/img/home/claw-machine/press-bg.png')
      }, null, 8, ["class", "src"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_image, {
          class: "ball-icon",
          fit: "contain",
          src: require('@/assets/img/home/claw-machine/ball.png')
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_5, "X" + _toDisplayString(_unref(catchDollCount)), 1)
      ]),
      _createVNode(_component_van_button, {
        class: "press-btn",
        disabled: _unref(catchDollCount) <= 0,
        onClick: doCatchDoll
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('catchDoll.press').toUpperCase()), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "action-btn deposit",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push({ name: 'recharge' })))
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_image, {
          class: "action-btn-icon",
          fit: "contain",
          src: require('@/assets/img/home/finance-bar/deposit-icon.png')
        }, null, 8, ["src"]),
        _createVNode(_component_van_image, {
          class: "action-btn-text",
          fit: "contain",
          src: require('@/assets/img/home/finance-bar/deposit-text.png')
        }, null, 8, ["src"])
      ])
    ])), [
      [_directive_audio]
    ]),
    (showReward.value)
      ? (_openBlock(), _createBlock(_unref(Reward), {
          key: 0,
          rewards: rewards.value,
          onOnClose: _cache[2] || (_cache[2] = $event => (showReward.value = false))
        }, null, 8, ["rewards"]))
      : _createCommentVNode("", true)
  ]))
}
}

}